import { VisibilityState } from '@tanstack/vue-table'

import { ClinicType, PatientType, InvoiceType, TemplateType } from '@/types'

export enum ProposalStatusEnum {
  DRAFT = 'draft',
  SENT = 'sent',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  EXPIRED = 'expired',
}

export type ProposalSectionFormType = {
  template_id: string
  content?: string
  title?: string
  type: string
  order: number
  is_enabled?: boolean
  include_in_pdf?: boolean
  custom_data?: Record<string, string>
}

export type ProposalSectionType = {
  id: string
  proposal_id: string
  section_type: string
  order: number
  is_enabled: boolean
  include_in_pdf: boolean
  custom_data?: Record<string, string>
  has_document: boolean
  required_models?: {
    primary: string[]
    secondary: string[]
  }
  template: TemplateType
  created_at: string
  updated_at: string
}

export type ProposalType = {
  id: string
  invoice_id: string
  number: string
  status: ProposalStatusEnum
  title: string
  description?: string
  sent_at?: string
  expires_at?: string
  created_at: string
  updated_at: string
  deleted_at?: string
  sections: ProposalSectionType[]
  clinic: ClinicType
  invoice: InvoiceType
  recipient: PatientType
  has_enabled_sections: boolean
}

export type PublicProposalType = ProposalType & {
  enabled_sections_count: number
  has_main_document: boolean
  has_pdf_sections: boolean
  pdf_sections_count: number
}

export type PublicProposalSectionType = {
  html: string
  order: number
  title?: string
  type: string
  custom_data?: Record<string, string>
}

export type PublicProposalResponseType = {
  sections: PublicProposalSectionType[]
  proposal: PublicProposalType
  message?: string
}

export type ProposalFilterType = {
  expired?: string
  expiring_soon?: string
  has_sections?: string
  archived?: string
  status: ProposalStatusEnum[]
  columnVisibility?: VisibilityState
  columnOrder: string[]
}

export type ProposalFormType = {
  invoice_id: string
  title: string
  description?: string
  sections: ProposalSectionFormType[]
}
